export default {
  unionDashboard: {
    // titles per role-scoped variant
    titleParent: "Panel Nacional",
    titleUnion: "Panel de la Unión",
    titleSociety: "Panel de la Sociedad",
    titleFactory: "Panel de la Fábrica",
    eudrTitle: "Diligencia Debida EUDR",
    // filters
    factory: "Fábrica",
    society: "Sociedad",
    union: "Unión",
    dateRange: "Rango de Fechas",
    // identifiers
    unionNumbers: "Cifras de la Unión",
    societyNumbers: "Cifras de la Sociedad",
    factoryNumbers: "Cifras de la Fábrica",
    // core KPIs
    totalFarmers: "Total de Agricultores",
    totalFarms: "Total de Fincas",
    totalReceiving: "Total Recibido",
    totalProcessing: "Total Procesado",
    // tiered KPIs (parent, test org): society = factory tier, union = union tier
    receivingBySociety: "Recepción por Sociedad",
    processingBySociety: "Procesamiento por Sociedad",
    receivingByUnion: "Recepción por Unión",
    processingByUnion: "Procesamiento por Unión",
    // operational
    unions: "Uniones",
    societies: "Sociedades",
    mills: "Fábricas de Molienda en Seco",
    crops: "Cultivos",
    bushes: "Arbustos / Árboles",
    // charts
    receivingVsProcessing: "Recepción vs Procesamiento",
    receivingVsProcessingTT: "Cereza recibida en comparación con la producción procesada.",
    breakdownByUnion: "Recepción vs Procesamiento por Unión",
    breakdownBySociety: "Recepción vs Procesamiento por Sociedad",
    breakdownByFactory: "Recepción vs Procesamiento por Fábrica",
    breakdownByCrop: "Recepción vs Procesamiento por Cultivo",
    receiving: "Recepción",
    processing: "Procesamiento",
    kilograms: "Kilogramos (kg)",
    avgQualityScore: "Puntuación Media de Calidad",
    avgQualityScoreTT: "Puntuación media agregada de catación/calidad para este ámbito.",
    avgScore: "Puntuación Media",
    greenCoffeeGrades: "Niveles de Calidad del Café Verde",
    greenCoffeeGradesTT: "Distribución del café verde por grados de calidad.",
    bags: "Sacos",
  },
};
